import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { icons, LucideAngularModule } from 'lucide-angular';
import { InlineSVGModule } from 'ng-inline-svg-2';

@NgModule({
  declarations: [],
  imports: [CommonModule, LucideAngularModule.pick(icons), InlineSVGModule],
  exports: [CommonModule, LucideAngularModule, InlineSVGModule],
})
export class SharedModule {}
